<template>
    <el-dialog :title="(formData.edit? $t('Update folder'):$t('Create Folder'))" :visible.sync="dialogFormVisible" :before-close="handleClose" @open="handleOpen('formData')" width="30%">
        <el-form label-position="top" :model="formData" ref="formData" class="demo-dynamic">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item :label="$t('Name')" prop="folder_name" :rules="[{ required: true, message: $t('This field is required')}]">
                    <el-input v-model="formData.folder_name"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item :label="$t('Folder ID')" prop="folder_link" :rules="[{ required: true, message: $t('This field is required')}]">
                    <el-input v-model="formData.folder_link"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="organizationList">
                <el-form-item :label="$t('Organization')" prop="name">
                    <el-select :placeholder="$t('Select Contacts')" v-model="access_users1" multiple collapse-tags :popper-append-to-body="false" @change="mergeContacts" filterable>
                        <el-option v-for="(item, id) in organizationList" :label="item" :key="id" :value="id"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="fachstellenList">
                <el-form-item :label="$t('Fachstellen')" prop="name">
                    <el-select :placeholder="$t('Select Contacts')" v-model="access_users2" multiple collapse-tags :popper-append-to-body="false" @change="mergeContacts" filterable>
                        <el-option v-for="(item, id) in fachstellenList" :label="item" :key="id" :value="id"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="clubMemberList">
                <el-form-item :label="$t('Voters')" prop="name">
                    <el-select :placeholder="$t('Select Contacts')" v-model="access_users3" multiple collapse-tags :popper-append-to-body="false" @change="mergeContacts" filterable>
                        <el-option v-for="(item, id) in clubMemberList" :label="item" :key="id" :value="id"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :lg="24">
                <el-form-item>
                    <el-button type="primary" @click="submitForm('formData')" size="medium">{{ (formData.edit?
                        $t('Update'):$t('Save')) }}</el-button>
                    <el-button type="cancel" @click="$emit('popup',false)" size="medium">{{ $t('Cancel') }}</el-button>
                </el-form-item>
            </el-col>
            <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
        </el-form>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            dialogFormVisible: Boolean,
            rowData: Object,
            organizationList: Object,
            fachstellenList: Object,
            clubMemberList: Object
        },
        data() {
            return {
                formData: {
                    access_users: []
                },
                access_users1: [],
                access_users2: [],
                access_users3: [],
                formLabelWidth: '120px'
            };
        },
        methods: {
            mergeContacts(val) {
                this.formData.access_users = val;
                this.formData.access_users = this.formData.access_users.concat(this.access_users1, this.access_users2, this.access_users3)
                this.formData.access_users = this.formData.access_users.filter(function (item, pos, self) {
                    return self.indexOf(item) == pos;
                })
                this.formData.access_users = this.formData.access_users.map(Number)
            },
            handleOpen() {
                this.formData = Object.assign({}, this.rowData);
                this.$nextTick(() => {
                    this.$refs['formData'].clearValidate();
                    if(this.formData.access_users && this.formData.access_users.length){
                        this.access_users1 = Object.keys(this.organizationList).filter((item)=>{
                            return this.formData.access_users.includes(parseInt(item));
                        });
                        this.access_users2 = Object.keys(this.fachstellenList).filter((item)=>{
                            return this.formData.access_users.includes(parseInt(item));
                        });
                        this.access_users3 = Object.keys(this.clubMemberList).filter((item)=>{
                            return this.formData.access_users.includes(parseInt(item));
                        });
                    } else {
                        this.access_users1 = [];
                        this.access_users2 = [];
                        this.access_users3 = [];
                    }
                })
            },
            handleClose() {
                this.$emit('popup', false)
            },
            updateData(row) {
                return request({
                        url: "folder-links/" + row.id,
                        method: "PATCH",
                        data: row
                    })
                    .then(response => {
                        this.$emit('popupupdate', response.data.data);
                        this.$emit('popup', false);
                        this.$notify({
                            title: this.$t('Success'),
                            message: response.data.message,
                            type: "success",
                            offset: 50
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            title: this.$t('Error'),
                            message: error.response.data.message,
                            type: "error",
                            offset: 50
                        });
                    });
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        if (this.formData.edit)
                            return this.updateData(this.formData);
                        request({
                                url: "folder-links",
                                method: "post",
                                data: this.formData
                            })
                            .then(response => {
                                this.$emit('popup', false);
                                this.$emit('popupsave', false);
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: response.data.message,
                                    type: "success",
                                    offset: 50
                                });
                            })
                            .catch(error => {
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                            });
                    }
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Layout/FileManager/Form.vue